import React, {useEffect, useState} from 'react';
import CustomTextField, { type CustomTextFieldProps } from './CustomTextField';
import {updateStateAttribute} from '../helpers/helper';
import CLocalizedTextString from './CLocalizedTextString';

interface INumberInput extends Pick<CustomTextFieldProps, 'label' | 'value' | 'error' | 'helperText' | 'onEnter'> {
  onInputChange: (ev: number | undefined) => void;
  onValidChange?: (ev: number | undefined) => void; /* TODO: Keep value state in component so that on Valid Change can work as expected */
  value: number | undefined;
  gt?: number;
  geq?: number;
  lt?: number;
  leq?: number;
  hideArrows?: boolean;
}

interface State {
  error?: boolean;
  helperText?: string;
}
export default function CInputNumeric(props: INumberInput) {
  const [state, setState] = useState<State>({});

  const geqError = CLocalizedTextString('textField.error.geq');
  const gtError = CLocalizedTextString('textField.error.gt');
  const leqError = CLocalizedTextString('textField.error.leq');
  const ltError = CLocalizedTextString('textField.error.lt');
  const geqErrorSuffix = CLocalizedTextString('textField.error.geqSuffix');
  const gtErrorSuffix = CLocalizedTextString('textField.error.gtSuffix');
  const leqErrorSuffix = CLocalizedTextString('textField.error.leqSuffix');
  const ltErrorSuffix = CLocalizedTextString('textField.error.ltSuffix');

  const validateInput = (input?: number) => {
    let error: boolean | undefined;
    let helperText: string | undefined;

    if (props.gt !== undefined && ((input ?? 0) <= props.gt)) {
      error = true;
      helperText = gtError + ' ' + props.gt + ' ' + gtErrorSuffix;
    }

    if (props.geq !== undefined && ((input ?? (props.geq - 1)) < props.geq)) {
      error = true;
      helperText = geqError + ' ' + props.geq + ' ' + geqErrorSuffix;
    }

    if (props.lt !== undefined && ((input ?? 0) >= props.lt)) {
      error = true;
      helperText = ltError + ' ' + props.lt + ' ' + ltErrorSuffix;
    }

    if (props.leq !== undefined && ((input ?? (props.leq + 1)) > props.leq)) {
      error = true;
      helperText = leqError + ' ' + props.leq + ' ' + leqErrorSuffix;
    }

    updateStateAttribute<State>({error, helperText}, setState);

    if (!error) {
      props.onValidChange?.(input);
    }
  };

  useEffect(() => {
    validateInput(props.value);
  }, [props.value]);

  return (
    <span className={props.hideArrows ? 'hide-arrows' : ''}>
      <CustomTextField {...props}
                       type={'number'}
                       error={props.error ?? state.error}
                       onChange={(ev) => {
                         props.onInputChange(Number.isNaN(Number.parseInt(ev.currentTarget.value)) ? undefined : (ev.currentTarget.value.includes('.') ? Number.parseFloat(ev.currentTarget.value) : Number.parseInt(ev.currentTarget.value)));
                       }}
                       helperText={props.helperText ?? state.helperText} />
    </span>
  );
}
